import { useGetAllAssignmentCumulativeReportMutation, useGetStudentNameMutation, useGetSessionReportOptionsMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useReportContext } from '../../../../../reports/components/reportContext';
import { useParams } from 'react-router-dom';
import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useEffect, useState } from 'react';
import { DateFormatter } from '../../../../../../utils/DateFormatter';

const StudentCumulativeReport = () => {
  const [getCumulativeAssignmentReport] = useGetAllAssignmentCumulativeReportMutation();
  const [getSessionReportOptions] = useGetSessionReportOptionsMutation();
  const [getStudentName] = useGetStudentNameMutation();
  const [reportTitle, setReportTitle] = useState('Cumulative Class Report');
  const { Id, courseId, studentId } = useParams();
  const reportContext = useReportContext();
  reportContext.setSelectedClassId(parseInt(Id));
  reportContext.setSelectedCourseId(parseInt(courseId));
  reportContext.setSelectedStudentId(parseInt(studentId));
  reportContext.setIsAllReport(true);

  useEffect(() => {
    getReportTitle();
    getReportOptions();
  }, []);

  const getReportTitle = async () => {
    if (reportContext?.studentName) {
      setReportTitle(`Cumulative Report for ${reportContext.studentName}`);
    }
    else {
      try {
        const studentName = await getStudentName(studentId).unwrap();
        reportContext.setStudentName(studentName);
        setReportTitle(`Cumulative Report for ${studentName}`);
      } catch(ex) {
        console.log('error');
        console.log(ex);
        setReportTitle('Cumulative Student Report');
      }
    }
  };

  const getReportOptions = async () => {
    const reportOption = {
      reportOptionType: 1
    };

    try {
      const reportResponse = await getSessionReportOptions(reportOption).unwrap();
      reportContext.setStartDate(DateFormatter.toShortDate2(reportResponse.fromDate));
      reportContext.setEndDate(DateFormatter.toShortDate2(reportResponse.toDate));
    } catch {
      reportContext.setEndDate(DateFormatter.toShortDate2(new Date()));
      var thirtyDaysAgo = new Date();
      reportContext.setStartDate(DateFormatter.toShortDate2(thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)));
    }
  };

  var headerOptions = {
    reportTitle: reportTitle,
    showClassDropdown: false,
    showTeacherName: true,
    showStudentName: false,
    showClassName: false,
    isAllStudentReport: false,
    showRetryInfo: true,
    showTotalRow: false,
    showReportType: false,
    showIncludedQuestions: true
  };

  var reportOptions = {
    showTimePeriod: true,
    scoringThreshhold: true,
    showRetryScoring: true,
    hideDisplayNotStartedStudents: true
  };

  return (
    <>
      {
        reportContext.endDate && reportContext.startDate &&
        <QuestionBreakdownReport
          isRetakeReport={false}
          exportFileName='StudentCumilativeReport'
          reportDataEndpoint={getCumulativeAssignmentReport}
          headerOptions={headerOptions}
          reportOptions={reportOptions}
          isTeacherReport={true}
          goBackOnError={false}
          studentToIncludeTab={2}
          initialClassId={parseInt(Id)}
        />
      }
    </>
  );

};

export default StudentCumulativeReport;